import request from "@/utils/request"

export function login(params) {
    return request({
        url: `/oauth/token`,
        method: 'post',
        params
    })
}